import React, { useCallback, useContext, useEffect, useState } from "react";

import { useTheme } from "styled-components";
import { useStructureStore } from "../../../optics/components/drawers/settings/features/org-chart/store/structure-store";
import { ChartContext } from "../context";
import { getUserByAccountId } from "../../../api/people-api";
import { createDynamicProfileLink } from "../../../helpers/cosmos-profile-link";
import ViewSelector from "./ViewSelector";

function UserTemplate(node) {
  const [isLoading, setIsLoading] = useState(false);
  const [userInfo, setUserInfo] = useState();
  const theme = useTheme();
  const { selectedUser, setSelectedUser } = useStructureStore((state) => ({
    selectedUser: state.selectedUser,
    setSelectedUser: state.setSelectedUser,
  }));

  const { viewOptions, isPreview, isCosmosInstalled } =
    useContext(ChartContext);

  const fetchUserInfo = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getUserByAccountId(node.id);
      const user = JSON.parse(response.body);

      if (user) {
        setUserInfo({
          key: user.accountId,
          name: user.displayName,
          profilePictureSrc: `${window.AP._hostOrigin}${user?.profilePicture?.path}`,
        });
      }
    } catch (error) {
      setUserInfo({ error: true });
    } finally {
      setIsLoading(false);
    }
  }, [node?.id]);

  useEffect(() => {
    if (node?.id && node.id !== "root-level") {
      fetchUserInfo();
    }

    return () => {
      setUserInfo();
    };
  }, [node.id, fetchUserInfo]);

  const handleClickOnUser = (accountId, name) => {
    if (selectedUser?.id === accountId) {
      setSelectedUser(undefined);
    } else {
      setSelectedUser({ id: accountId, name });
    }
  };

  const openUserProfile = (accountId) => {
    const url = createDynamicProfileLink(accountId, isCosmosInstalled);
    window.open(url, "_blank");
  };

  if (node.id === "root-level") return <></>;

  return (
    <ViewSelector
      selectedView={viewOptions?.view}
      isPreview={isPreview}
      componentProps={{
        node,
        userInfo,
        selectedUser,
        onUserClick: handleClickOnUser,
        handleOpeningUserProfile: isPreview ? openUserProfile : undefined,
        isLoading,
        hasChildren: !!node?.children?.length,
      }}
      darkTheme={{
        backgroundColor: theme.background,
        titleColor: theme.orgchart.name,
        descriptionColor: theme.orgchart.description,
        boxShadow: theme.orgchart.boxShadow,
        minusPlusColor: theme.orgchart.minusPlusColor,
      }}
    />
  );
}

export default UserTemplate;
